import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

export enum SpecialLandingOffering {
  Total = 'Total',
}

export type LandingOffering = ProgramTypes | SpecialLandingOffering
export const LandingOffering = { ...ProgramTypes, ...SpecialLandingOffering }
